import script from "./PetBreeds.vue?vue&type=script&setup=true&lang=js"
export * from "./PetBreeds.vue?vue&type=script&setup=true&lang=js"

import "./PetBreeds.vue?vue&type=style&index=0&id=4f49dfba&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f49dfba"]])

export default __exports__